import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPython} from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import {faRobot, faBarChart} from '@fortawesome/free-solid-svg-icons'

// library.add(faCustom);
const labelsFirst = [
    "Python",
    "PyTorch",
    "scikit-learn (sklearn)",
    "SciPy",
    "NumPy",
    "Flask",
    "FastAPI",
    "SQL"
];

const labelsSecond = [
    "ArcGIS",
    "Geopandas",
    "folium",
    "keplergl",
];

const labelsThird = [
    "OpenAI",
    "Grok",
    "LangChain",
    "Hugging Face",
    "Ollama",
    "Streamlit",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>Machine Learning</h3>
                    <p>I have extensive knowledge in building machine learning models using Python from various sources of data.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faBarChart} size="3x"/>
                    <h3>Geospatial Analysis</h3>
                    <p>My experience in the military has provided me a domain of knowledge within geospatial analysis.  </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faRobot} size="3x"/>
                    <h3>GenAI & LLM</h3>
                    <p>Leverage the latest AI models in your projects. I have professional experience building GenAI solutions to help business strategy.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;